import type { RootState } from '../store';

export function panelNameSelector(state: RootState) {
  return state.panelInfo?.app_settings?.web_app_name || 'Loading...';
}

export function panelLanguagesSelector(state: RootState) {
  return state.domainInfo?.panels?.find((p) => p.uuid === state.panelInfo.guid)?.languages ?? [];
}

export function faviconUrlSelector(state: RootState) {
  return state.panelInfo?.app_theme?.logo_favicon_url;
}
